var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-main",staticStyle:{"height":"100%"}},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view',{key:_vm.key,class:_vm.transitionName!='none'?'child-view':''})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }